import React from "react";
import { dismissToast } from "shared/utils/toastNotification";

/**
 * @description Call this hook in page to close all notifications,
 * @param id if passed then only that particular toast will be closed
 */
function useDismissToast(id?: React.ReactText) {
  React.useEffect(() => {
    dismissToast(id);
  }, [id]);
}

export default useDismissToast;
